import { render, staticRenderFns } from "./EmployeeNomineeInfo.vue?vue&type=template&id=61c38386"
import script from "./EmployeeNomineeInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeNomineeInfo.vue?vue&type=script&lang=js"
import style0 from "./EmployeeNomineeInfo.vue?vue&type=style&index=0&id=61c38386&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports